import { createApi } from "@reduxjs/toolkit/query/react";
import { fetchBaseQueryByAxios } from "@/redux/api/fetchBaseQueryHelper";
import _ from "lodash";

/**
 * https://redux-toolkit.js.org/rtk-query/api/fetchBaseQuery#prepareheaders
 * here to learn more about the query
 * or see
 * `postSlice-example`, `userSlice-example`
 */
export const pickupApi = createApi({
	reducerPath: "pickup",
	baseQuery: fetchBaseQueryByAxios,
	endpoints: (builder) => ({
		getPickupLocation: builder.query({
			query: () => `/location/locationData`,
			transformResponse: (responseData) => {
				return responseData.data;
			},
		}),
		deletePickupLocation: builder.mutation({
			query(id) {
				return {
					url: `/location/locationById?location_id=${id}`,
					method: "DELETE",
				};
			},
		}),
		addPickupLocation: builder.mutation({
			query: (initialPost) => {
				return {
					url: "/location/newLocation",
					method: "POST",
					body: initialPost,
				};
			},
		}),
		updatePickupLocation: builder.mutation({
			query: (initialPost) => {
				return {
					url: "/location/locationById",
					method: "PUT",
					body: initialPost,
				};
			},
		}),
	}),
});

export const {
	useGetPickupLocationQuery,
	useAddPickupLocationMutation,
	useDeletePickupLocationMutation,
	useUpdatePickupLocationMutation,
} = pickupApi;
